module.exports = __webpack_public_path__ + "static/media/Config.5dc7f261.svg";